import apiHelpers from './apiHelpers';

export default {
    getEventsData(data, body) {
        return apiHelpers.httpRequest(`stats/history?precision=${data.precision}&events=${data.events.join(',')}&sandbox=${data.sandbox}&start=${encodeURIComponent(data.filter.date.start)}&end=${encodeURIComponent(data.filter.date.end)}&cohort=${data.filter.date.cohort}${data.filter.additional}&group-by-cohort=${data.groupByCohort}`, body, 'get');
    },
    getSubscriptionsData(data, body) {
        return apiHelpers.httpRequest(`stats/renewal?${data.filter.dates}${data.filter.additional}`, body, 'get');
    },
    getPredictions(data, body) {
        return apiHelpers.httpRequest(`stats/prediction?sandbox=${data.sandbox}${data.filter.dates}&cohort=${data.cohort}${data.filter.additional}${data.ltv ? `&precision=${data.precision}` : ''}&charts=${data.charts}${data.ltv ? `&ltv=${data.ltv}` : ''}`, body, 'get');
    },
    getHistoryActivations(data, body) {
        return apiHelpers.httpRequest(`stats/history/product_id?&precision=${data.precision}&events=${data.events.join(',')}&sandbox=${data.sandbox}&start=${encodeURIComponent(data.filter.date.start)}&end=${encodeURIComponent(data.filter.date.end)}&cohort=${data.cohort}${data.filter.additional}&group-by-cohort=true`, body, 'get');
    },
    setSummaryNotes(body) {
        return apiHelpers.httpRequest('stats/history/notes', body, 'post');
    },
};
